"use strict";

exports.__esModule = true;
exports.DeviceCycleChart = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
var _timelineDefinitions = require("../../Timeline/timelineDefinitions");
var _Charts = require("../../Charts");
var _PlantStateActivities = require("../../PlantStateActivities");
var _SelectionContext = require("../../Core/SelectionContext");
var _getAlphaBasedOnSelectionContext = require("../../Charts/StripeChart/getAlphaBasedOnSelectionContext");
var _excluded = ["theme", "timeline", "interval", "width", "height", "axis", "plantStateActivities", "path", "selection", "dataRange", "showLabel"];
var _dec, _dec2, _class, _DeviceCycleChart;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Shows a stripe chart for a particular device.
 */
var DeviceCycleChart = exports.DeviceCycleChart = (_dec = _PlantStateActivities.PlantStateActivitiesContext.withContext, _dec2 = _SelectionContext.SelectionContext.withContext, (0, _styledComponents.withTheme)(_class = _dec(_class = _dec2(_class = (_DeviceCycleChart = /*#__PURE__*/function (_Component) {
  function DeviceCycleChart() {
    var _this$colors;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.colors = (_this$colors = {}, _this$colors[_timelineDefinitions.TIME_SERIES_INSTANCE] = _this.props.theme.TimeLineInstanceColor, _this$colors[_timelineDefinitions.TIME_SERIES_PROCESS] = _this.props.theme.TimeLineProcessColor, _this$colors[_timelineDefinitions.TIME_SERIES_KIND] = _this.props.theme.TimeLineKindColor, _this$colors[_timelineDefinitions.TIME_SERIES_SHIFT] = _this.props.theme.TimeLineShiftColor, _this$colors);
    _this.getColor = function (item) {
      var theme = _this.props.theme;
      switch (item.type) {
        case _timelineDefinitions.TIME_SERIES_INSTANCE:
        case _timelineDefinitions.TIME_SERIES_PROCESS:
        case _timelineDefinitions.TIME_SERIES_SHIFT:
        case _timelineDefinitions.TIME_SERIES_KIND:
          return _this.colors[item.type];
        case _timelineDefinitions.TIME_SERIES_CLASSIFICATION:
          return (0, _PlantStateActivities.getPlantStateColor)(theme, item.value.state);
        default:
          throw new Error("Unsupported timeline " + item.type);
      }
    };
    _this.getCategoryColor = function (item) {
      if (item.value.classification_source === "user-input") {
        return "rgba(0, 0, 0, 0.2)";
      }
      return "rgba(0, 0, 0, 0)";
    };
    _this.getLabel = function (item) {
      switch (item.type) {
        case _timelineDefinitions.TIME_SERIES_SHIFT:
          return item.value.shift ? item.value.shift.join(", ") : "None";
        case _timelineDefinitions.TIME_SERIES_KIND:
          return item.value.part_kind;
        case _timelineDefinitions.TIME_SERIES_INSTANCE:
          return item.value.part_instance;
        case _timelineDefinitions.TIME_SERIES_PROCESS:
          return item.value.part_process;
        default:
          return null;
      }
    };
    return _this;
  }
  _inheritsLoose(DeviceCycleChart, _Component);
  var _proto = DeviceCycleChart.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      theme = _this$props.theme,
      timeline = _this$props.timeline,
      interval = _this$props.interval,
      width = _this$props.width,
      height = _this$props.height,
      axis = _this$props.axis,
      allPlantStateActivities = _this$props.plantStateActivities,
      path = _this$props.path,
      selection = _this$props.selection,
      dataRange = _this$props.dataRange,
      showLabel = _this$props.showLabel,
      extra = _objectWithoutPropertiesLoose(_this$props, _excluded);
    var plantStateActivities = (0, _PlantStateActivities.getEnabledPlantStateActivities)(allPlantStateActivities);
    var getAlpha = (0, _getAlphaBasedOnSelectionContext.getAlphaBasedOnSelectionContext)({
      dataRange: dataRange,
      selectionContext: selection,
      valueKey: "value"
    });
    return /*#__PURE__*/_react["default"].createElement(_Charts.StripeChart, _extends({
      getLabelColor: function getLabelColor() {
        return "white";
      },
      getLabel: showLabel ? this.getLabel : null,
      interval: interval,
      timeline: timeline,
      getColor: this.getColor,
      getAlpha: getAlpha,
      getCategoryColor: this.getCategoryColor,
      renderTooltip: renderTooltip(plantStateActivities, theme),
      width: width,
      height: height,
      axis: axis,
      path: path
    }, extra));
  };
  return DeviceCycleChart;
}(_react.Component), _DeviceCycleChart.defaultProps = {
  theme: undefined,
  plantStateActivities: undefined,
  selection: undefined
}, _DeviceCycleChart)) || _class) || _class) || _class);
function renderTooltip(plantStateActivities, theme) {
  return function (item) {
    var type = item.type;
    if (type === _timelineDefinitions.TIME_SERIES_SHIFT) {
      return item.value.shift ? item.value.shift.join(", ") : "None";
    }
    if (type === _timelineDefinitions.TIME_SERIES_KIND) {
      return item.value.part_kind;
    }
    if (type === _timelineDefinitions.TIME_SERIES_INSTANCE) {
      return item.value.part_instance;
    }
    if (type === _timelineDefinitions.TIME_SERIES_PROCESS) {
      return item.value.part_process;
    }
    if (type === _timelineDefinitions.TIME_SERIES_CLASSIFICATION) {
      var labels = [getState(item.value.state, plantStateActivities), getActivity(item.value.activity, plantStateActivities)].filter(function (label) {
        return !!label;
      });
      var marginBottom = labels.length > 1 ? "5px" : "none";
      var borderBottom = labels.length > 1 ? "1px solid " + (theme.uiModern ? theme.TooltipContentBorderBottomColor : "#b7b7b7") : "none";
      return labels.map(function (label, index) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: "Tooltip." + label,
          style: {
            borderBottom: labels.length - 1 !== index ? borderBottom : "none",
            color: theme.TooltipContentColor,
            marginBottom: marginBottom,
            width: "max-content",
            maxWidth: "200px"
          }
        }, label);
      });
    }
    return null;
  };
}
var getState = function getState(id, plantStateActivities) {
  if (!plantStateActivities) {
    return id;
  }
  var state = plantStateActivities.states.find(function (s) {
    return s.id === id;
  });
  return state ? state.name : id;
};
var getActivity = function getActivity(id, plantStateActivities) {
  if (!plantStateActivities) {
    return id;
  }
  var activity = plantStateActivities.activities.find(function (a) {
    return a.id === id;
  });
  return activity ? activity.name : decodeURIComponent(id);
};